<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent class="select-dynamic-attribute">
    <template #activator="{ on }">
      <div class="mf-select-dynamic-attributes-dialog-input-container" @click="!loading ? (dialog = true) : null">
        <v-row no-gutters>
          <v-col class="py-0" align="center">
            <mf-button label="Selecionar Atributo" :loading="loading" data-cy="dynamic-attributes-button" @click="dialog = true" />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col align="left" class="pt-2">
            <v-chip v-if="lazySelectedDynamicAttribute" small close @click:close="unsetAttribute">
              {{ lazySelectedDynamicAttribute.label }}
            </v-chip>
          </v-col>
        </v-row>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <span class="mf-h6 primary-text">Selecionar atributo dinâmico</span>
      </v-card-title>
      <v-card-subtitle class="py-2">
        <span> O valor dos atributos dinâmicos é atualizado automaticamente de acordo com a integração durante a atualização da plataforma </span>
      </v-card-subtitle>
      <v-card-text>
        <v-row no-gutters>
          <v-col class="py-2">
            <mf-search v-model.lazy="delaySearch" placeholder="Buscar atributo dinâmico" hide-details />
          </v-col>
        </v-row>
        <v-row v-show="lazySelectedDynamicAttribute" no-gutters>
          <v-col>
            <v-chip small>
              {{ lazySelectedDynamicAttribute && lazySelectedDynamicAttribute.label }}
            </v-chip>
          </v-col>
        </v-row>
        <div>
          <v-data-table
            :items="items"
            :headers="headers"
            item-key="attribute"
            hide-default-footer
            disable-pagination
            show-select
            single-select
            class="mt-2 row-pointer"
            fixed-header
            no-data-text="Nenhum resultado encontrado"
            data-cy="dynamic-attributes-table"
            height="400px"
            @click:row="toggleRow"
          >
            <template #[`item.data-table-select`]="{ item }">
              <v-radio-group v-model="localSelectedDynamicAttribute" dense hide-details class="mt-0 pt-0">
                <v-radio :value="item" />
              </v-radio-group>
            </template>
            <template #[`item.type`]="{ item }">
              {{ formatType(item.type) }}
            </template>
            <template #[`item.origin`]="{ item }">
              {{ formatOrigin(item.origin) }}
            </template>
            <template #[`item.last_updated_at`]="{ item }">
              {{ formatTimestamp(item.last_updated_at) }}
            </template>
          </v-data-table>
        </div>
      </v-card-text>
      <v-card-actions class="text-right">
        <v-row justify="end" no-gutters>
          <mf-button label="Cancelar" text class="mr-2" @click="cancel" />
          <mf-button label="Selecionar" class="mr-3" @click="confirm" />
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { diacriticSpaceSensitiveRegex } from '@/helpers/search'
import { DateTime } from 'luxon'

export default {
  name: 'SelectDynamicAttributesDialog',
  props: {
    dynamicAttributes: {
      type: Array,
      default: () => [],
    },
    selectedDynamicAttribute: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    lazySelectedDynamicAttribute: null,
    delaySearch: '',
    localSelectedDynamicAttributes: [],
    localSelectedDynamicAttribute: {},
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Atributo',
          value: 'label',
          sortable: false,
        },
        {
          text: 'Tipo',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Origem',
          value: 'origin',
          sortable: false,
        },
        {
          text: 'Última atualização em',
          value: 'last_updated_at',
          sortable: false,
        },
      ]
    },
    items() {
      if (this.delaySearch) {
        const searchRegex = diacriticSpaceSensitiveRegex(this.delaySearch)
        return this.dynamicAttributes.filter((attribute) => attribute.label.match(searchRegex) || attribute.value?.match(searchRegex))
      }
      return this.dynamicAttributes
    },
  },

  watch: {
    selectedDynamicAttribute(value) {
      this.lazySelectedDynamicAttribute = this.dynamicAttributes.find((da) => da._id === value._id)
      this.localSelectedDynamicAttribute = this.lazySelectedDynamicAttribute
    },
  },

  mounted() {
    if (this.selectedDynamicAttribute) {
      this.lazySelectedDynamicAttribute = this.dynamicAttributes.find((da) => da._id === this.selectedDynamicAttribute._id)
      this.localSelectedDynamicAttribute = this.lazySelectedDynamicAttribute
    }
  },

  methods: {
    toggleRow(row) {
      this.localSelectedDynamicAttribute = row
    },
    unsetAttribute() {
      this.lazySelectedDynamicAttribute = null
      this.localSelectedDynamicAttribute = null
      this.$emit('update:selectedDynamicAttribute', null)
    },
    cancel() {
      this.dialog = false
    },
    confirm() {
      const selectedAttribute = this.localSelectedDynamicAttribute
      if (selectedAttribute) {
        this.lazySelectedDynamicAttribute = selectedAttribute
        this.$emit('update:selectedDynamicAttribute', selectedAttribute)
      }
      this.dialog = false
    },

    // Formatters
    formatType(type) {
      const formats = {
        INTEGER: 'Número inteiro',
        OPTIONS: 'Seleção de lista',
        TEXT: 'Texto aberto',
        FLOAT: 'Número decimal',
        BOOLEAN: 'Booleano (Sim ou Não)',
      }
      return formats[type] || '-'
    },
    formatOrigin(type) {
      const formats = {
        IMPORTED: 'Importado via integração',
        USER_EXTRA_DATA: 'Cadastrado via canais Mercafacil',
      }
      return formats[type] || '-'
    },
    formatTimestamp(isoTS) {
      return DateTime.fromISO(isoTS).toFormat('dd/MM/yyyy HH:mm:ss')
    },
  },
}
</script>

<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
